<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="!(storeProducts && storeProducts.length == 0 && storeProductsInfo.currentPage == 1 && !loadingData  && search == null && sortLastCreated == false)" @input="searchProducts" @resetSearch="resetSearch"/>
      </v-col>
       <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto d-flex align-right justify-end mt-6"
      >
        <div>
          <v-btn 
            text 
            @click="clearFilter()" 
            class="text-body-2 text-none no-hover"
            :ripple="false"
          >
            {{ $t('clear') }}
          </v-btn>
          <SortOptions :sort-last-created="sortLastCreated" @setSort="setSort"/>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="(!storeProducts || storeProducts.length == 0) && storeProductsInfo.currentPage == 1 && !loadingData && search == null" align="center"
      class="mx-auto">
      <v-col cols="4"
        class="mx-auto px-0">
     
    <v-hover
      color="accent"
      class="create-product-card"
    >
      <v-card
      data-testid="create-product-card"
        slot-scope="{ hover }"
        :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
        class="fill-height py-10"
        rounded="xxl"
        align="center"
      >
            
        <v-card-title class="text-h5 font-weight-bold text-center justify-center mt-12 mb-4 no-break">
          {{ $t('createProductCardTitle') }}
       </v-card-title>
  
        <v-card-text class="text-body-1 text-center justify-center pb-8">
          <v-img
            :src="require('../../assets/create-product.png')"
            width="100%"
            max-width="400px"
            class="mx-auto"
          />
          <!-- eslint-disable vue/no-v-html -->
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-12 pt-0">
          <v-btn
            ref="create"
            data-testid="create-button-product"
            color="accent"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 "
            @click="navigateToCreateProduct"
          >
           {{ $t('createProductBtn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>

      </v-col>
    </v-row>
    <v-row
      v-if="storeProducts.length > 0 && !loadingData"
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="(product) in storeProducts"
          :key="product.id"
          :ripple="false"
          data-testid="store-product-card"
          rounded="xxl"
          class="my-2 solo"
          @click="showProductDetail(product.id)"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="11"
                align-self="center"
                class="px-6"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ product.attributes.title }}
                </v-card-text>
              </v-col>
              <v-col
                v-if="product.relationships.user.data.id == userId"
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list">
                    <v-list-item
                      data-testid="edit-product-item"
                      router
                      @click="openEditDialog(product)"
                    >
                      <v-list-item-title> 
                        {{ $t('edit') }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      data-testid="delete-product-item"
                      router 
                      @click.stop="
                        selectedProductIdForDeletion= product,
                        dialogVisible=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleDeleteProduct'), 
                        confirmationDialogText=$t('confirmationDialogTextDeleteProduct'), 
                        confirmationDialogSubmitBtn=$t('delete')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="12"
                md="11"
                class="px-6"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('title') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ product.attributes.title }}
                </div>
              </v-col>
              <v-col
                v-if="product.relationships.user.data.id == userId"
                cols="12"
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  ref="menuRef"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list">
                    <v-list-item
                      data-testid="edit-product-item"
                      router
                      @click="openEditDialog(product)"
                    >
                      <v-list-item-title> 
                        {{ $t('edit') }}
                      </v-list-item-title>
                    </v-list-item>
                     <v-list-item
                      data-testid="delete-product-item"
                      router 
                      @click.stop="
                        selectedProductIdForDeletion= product,
                        dialogVisible=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleDeleteProduct'), 
                        confirmationDialogText=$t('confirmationDialogTextDeleteProduct'), 
                        confirmationDialogSubmitBtn=$t('delete')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="storeProducts.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="storeProductsInfo.total"
      :page-number="storeProductsInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <PlusButtonWithLink
      data-testid="create-product-button"
      rounded="xl"
      :link="link"
    />
    <EditStoreProduct 
      v-if="selectedProduct.attributes && visibleDialogEditStoreProduct"
      :visible="visibleDialogEditStoreProduct"
      :product-title="selectedProduct.attributes.title"
      :product-description="selectedProduct.attributes.description"
      :product-price="selectedProduct.attributes.price"
      :product-currency="selectedProduct.attributes.currency_id"
      :product-tax="selectedProduct.attributes.tax"
      :product-entity="selectedProduct.attributes.productable"
      :product-entity-type="selectedProduct.relationships.productable.data.type"
      :product-entity-owner="selectedProduct.meta.productable_owner"
      :product-image-u-r-l="selectedProduct.attributes.image"
      :product-image-path="null"
      :product-id="selectedProduct.id"
      :product-orders="selectedProduct.attributes.orders"
      :product-participants-limit="selectedProduct.attributes.participants_limit"
      :product-additional-attributes-for-participants="Object.keys(selectedProduct.attributes.additional_attributes_for_participants).length !== 0 ? selectedProduct.attributes.additional_attributes_for_participants : {}"
      @close="visibleDialogEditStoreProduct = false"
      @proceedSubmit="editStoreProduct"
    />
    <ConfirmationDialog
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog" 
      @close="dialogVisible=false"
      @proceedSubmit="deleteProduct(selectedProductIdForDeletion)"
    />
  </nav>
</template>
<script>
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getStoreProducts, deleteProduct, searchStoreProducts } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import Pagination from '../../components/Pagination'
import EditStoreProduct from './EditStoreProduct'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import SearchBarExpanding from '../../components/SearchBarExpanding'
import SortOptions from '../../components/SortOptions'

export default {
    components: {
        PlusButtonWithLink,
        AlertMessages,
        Pagination,
        EditStoreProduct,
        ConfirmationDialog,
        SearchBarExpanding,
        SortOptions
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
          link: {title: i18n.t('createProductTitle'), route: '/product/create'},
          storeProducts: [],
          alertType: '',
          alertMsg: '',
          alertValue:false,
          spaceId: window.$cookies.get('space_id'),
          loadingData: false,
          storeProductsInfo: {
            currentPage: 1,
            total: 1,
          },
          size: 15,
          pageNumber: 1,
          paginationKey: '',
          visibleDialogEditStoreProduct: false,
          selectedProduct: {},
          userId: window.$cookies.get('id'),
          dialogVisible: false,
          confirmationDialogTitle: '',
          confirmationDialogText: '',
          confirmationDialogSubmitBtn: '',
          confirmationDialogCancelBtn: '',
          selectedProductIdForDeletion: '',
          search: null,
          totalProducts: 0,
          sortLastCreated: false
        }
    },
    async created(){
        if(this.$route.params.successfullyCreatedStoreProduct){      
            this.alertType = 'success'    
            this.alertMsg = i18n.t('newProductSuccessMsg')
            this.alertValue = true
        }
       
        this.loadingData = true
        await this.fetchStoreProducts()
        this.loadingData = false
    },
    methods:{
        showProductDetail(id){
            this.$router.push({path: '/store/product/' + id })
        },

        async searchProducts(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchStoreProducts(this.spaceId,keyword,this.pageNumber, this.size, this.sortLastCreated)
                  if(response){
                      if(response.status == 200){
                        this.storeProducts = response.data.data
                        if(this.storeProducts.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.searchProducts(keyword)
                        }else {
                            this.storeProductsInfo = response.data.meta.page
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.storeProductsInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchStoreProducts()
          this.search = null
          this.paginationKey = Date.now()
          return
        },

        handlePageChange(value){
            this.storeProductsInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchStoreProducts()
            }else {
              this.searchProducts(this.search)
            }
        },
        async fetchStoreProducts(){
            try {
                const response = await getStoreProducts(this.spaceId, this.pageNumber, this.size, this.sortLastCreated)
                if(response.status){
                    if(response.status == 200) {
                        this.storeProducts = response.data.data
                        if(this.storeProducts.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.fetchStoreProducts()
                        }else {
                          this.storeProductsInfo = response.data.meta.page
                          this.totalProducts = response.data.meta.page.total
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        closeMenu(index){
            this.$refs.menuRef[index].isActive = false
        },
        openEditDialog(item){
            this.selectedProduct=item
            this.visibleDialogEditStoreProduct = true
        },
        async editStoreProduct(msg, type){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            await this.fetchStoreProducts()          
        },
        navigateToCreateProduct() {
          this.$router.push({ path: '/product/create' });
        },
        async deleteProduct(product){
            this.alertMsg=''
            this.dialogVisible = false
            try{
                let data = {
                    data: {
                        type: "store-products", 
                        id: product.id,
                        attributes: {
                            deleted_at: this.currentDate()
                        },
                        relationships: {
                            space: {
                                data: {
                                    type: "spaces",
                                    id: this.spaceId
                                }
                            }
                        },
                    }
                }
                const response = await deleteProduct(product.id, data)
                if(response.status == 200) {
                    if(this.search == null){
                        await this.fetchStoreProducts()
                    }else {
                        await this.searchProducts(this.search)
                    }
                    this.alertType = 'success'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('deleteProductSuccess')
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            this.alertValue = true
                            if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                this.$router.push({name: 'PageAccessDenied'})
                            }
                            else {
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    } else{
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async setSort(option){
          if(option == 'lastCreated'){
            this.sortLastCreated = true
            if(this.search == null){
              await this.fetchStoreProducts()
          }else{
              await this.searchProducts(this.search)
            }
          }
        },

        async clearFilter(){
          this.sortLastCreated = false
          if(this.search == null){
            await this.fetchStoreProducts()
          }else{
            await this.searchProducts(this.search)
          }
        }
    }
}
</script>
